class ConnectionHealthService {
    constructor(wtcpjsClientProviderService, $rootScope, $log) {
        this.client = wtcpjsClientProviderService.getClient();

        this.client.onConnectionInfoUpdated.subscribe((data) => {
            $rootScope.$applyAsync(($scope) => {
                $rootScope.$broadcast("connectionHealthService.infoUpdated", data);
            });
        });
    }
    pingServer() {
        //Doesn't do anything now, but maybe could add way to force connection health info to update
    }
}

angular.module('webcomm').service('connectionHealthService', ['wtcpjsClientProviderService', '$rootScope', '$log', ConnectionHealthService]);